import { Search, VisibilityRounded, CloseRounded as CloseIcon, Edit } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState, useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, CheckBoxWithLabel, CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, EntityStatus, FormActions, FormatPrice, generateCodSobreCosto, getLabelMunicipio, RutaEntity, TiposVehiclos, TipoVehiculoEntity } from "../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../components/form/ModalForm";
import { SubItemTable } from "../../components/table/table-components";
import { FilterForm } from "../../components/form/filter-form";



const schema = yup.object({
 // detalle: yup.array().required(),
 
}).required();
const InitialFilterSearch = {
  rows_per_page: 20,
  page_number: 0,
  filter_search: "",
  centro_operacion_select:""
};

const schemaFilter = yup.object({
  centro_operacion_select:yup.mixed().required()
  }).required();

export const MaestroSobreCostoBodegas = () => {

  const [dataSetProdctos, setDataSetProductos] = useState([]);
  const [filterSearchPagination, setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows, setTotalRows] = useState(0);
  const { dispatch, store } = useContext(AppContext);
  const [isVisibleModalDetalle, setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState({ ...RutaEntity });
  const [tipoAction, setTipoAction] = useState(FormActions.AGREGAR);
  const [modalFilterOptions, setModalFilterOptions] = useState({ centro_op: [], bodegas: [] });
  const [tiposSobreCostos,setTiposSobreCostos] = useState([]);
  const [centrosOpOoptions,setCentrosOpOptions] = useState([]);




  useEffect(() => {

    loadItems();
    loadListadoTipoSobreCostos();

  }, []);


  useEffect(() => {

    loadItems(filterSearchPagination.filter_search ? false : true);
  }, [filterSearchPagination]);
  const loadItems = async (loading = true) => {
    setDataSetProductos([]);
    if (loading) {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
    }

    let { data: { value } } = await AxiosInstance.post("maestros/obtener-maestros-sobrecostos-bodegas", {
      ...filterSearchPagination,
      page_number: filterSearchPagination.page_number + 1
    });
    
    setDataSetProductos([...value.data]);

    setTotalRows(value.total);
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: false
    });

  }
  const loadListadoTipoSobreCostos = async()=>{

     let {data:{value}} = await  AxiosInstance.get("maestros/obtener-tipos-sobrecostos/BODEGA");
     setTiposSobreCostos(value);

  }

  const handleChangePage = (event, newPage) => {

    setFilterSearchPagination({ ...filterSearchPagination, page_number: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilterSearchPagination({ ...filterSearchPagination, rows_per_page: parseInt(event.target.value, 10) });

  };



  const onShowDetailProduct = (cod_prod) => {
   
    let product = dataSetProdctos.find(prod => prod.cod === cod_prod);
    console.log({product});
    let dataFormPayload = {}
    dataFormPayload["centro_operacion"] = {
      label:product.nombre_centro_op,
      value:product.cod_centro_operacion  }
    dataFormPayload["bodega"] ={
      label:product.descripcion,
      value:product.cod  }
   
    dataFormPayload["cod"] = cod_prod;
    product.detalle.forEach(ele=>{
      dataFormPayload[  ele.tipo_sobre_costo_desc ] = Number(ele.valor);
    });
    console.log({dataFormPayload});
    setTipoAction(FormActions.MODIFICAR);
 setProductoSeleccionado(dataFormPayload || {});

    
    onOpenModalItem(true);
  }

  const onOpenModalItem = (edit = false) => {
    console.log({ edit });
    if (!edit) {
      setProductoSeleccionado({ ...RutaEntity });
      setTipoAction(FormActions.AGREGAR);
    }
    setIsVisibleModalDetalle(true);
  }
  const onSaveDataForm = async (typeAction, dataForm) => {

   
    const urlService = typeAction === FormActions.AGREGAR ? 'maestros/crear-sobrecosto' : 'maestros/mod-sobrecosto/';
    console.log({
      typeAction,
      dataForm
    });
   
    setIsVisibleModalDetalle(false);
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: true
    });

      
      try{
        const Registro =  dataSetProdctos.find(prod => prod.cod === dataForm.cod);
        let payload = {}; 
        payload['bodega'] = Registro.cod; 
        payload['sobrecostos'] = [];
        tiposSobreCostos.map( async(tipo_sobre)=>{
          let valueSobreCosto = dataForm[tipo_sobre.descripcion];
          console.log({valueSobreCosto,tipo_sobre});
          payload['sobrecostos'].push({
            cod:tipo_sobre.cod,
            value:valueSobreCosto?valueSobreCosto:0
          })
        })
        console.log({payload});
        try{
          await  AxiosInstance.post("maestros/maestros-registrar-sobrecostos-bodegas" , payload);
        }catch(e){
            console.log(e.message);
        }
       
       
         await loadItems();
         dispatch({
          type: ActionTypes.setLoadingPage,
          data: false
        });
     
  
       }catch(e){
        console.log(e.message);
        dispatch({
          type: ActionTypes.setLoadingPage,
          data: false
        });
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error",
            message: "Error de comunicacion verifique su conexion a internet",
            type: DialogType.peligro,
            isVisible: true
          }
        });
       }

    

   



  }







const columnsTable = [
 

  {

    key: "cod_erp",
    keyValue: "cod_erp",
    label: "Codigo erp",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value}`,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "bodega",
    keyValue: "descripcion",
    label: "Bodega",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value} `,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "nombre_centro_op",
    keyValue: "nombre_centro_op",
    label: "Centro operacion",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value}`,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "tipos_sobre_costos",
    keyValue: "detalle",
    label: "Sobrecostos (KG)",

    headerRender: (props) => props.label,
    bodyRender: (props) => <SubItemTable
      cols={[{
        label: "Tipo",
        valueKey: "nombre_sobrecosto",
        keyRow: "cod",
       
      },
      {
        label: "Valor",
        valueKey: "valor",
        keyRow: "cod",
        format:FormatPrice
      }
      ]}
      typeView="horizontal"
      items={props.value} />,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },

  {
    key: "editar",
    keyValue: "cod",
    label: "Editar",
    headerRender: (props) => props.label,
    bodyRender: ({ value }) => <Button onClick={e => onShowDetailProduct(value)} variant="contained" startIcon={<Edit />} >Editar</Button>,
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
];

const onSearchCentroOpModal = async (value_search, type_enter) => {

  if (value_search && value_search.length > 3) {
      try {

          const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-centros-operacion-filtros", {
              search_query: value_search
          });
          setModalFilterOptions({...modalFilterOptions,centro_op:[...value]})
        
          return value;
      } catch (e) {
          return [];
      }

  }

}

const onSearchBodegaModal = async (value_search, type_enter) => {

  return []

}

const configModal = {
  titleModal: tipoAction === FormActions.AGREGAR ? "Agregar nueva sobrecosto" : 'Modificar sobrecosto bodega',
  buttomsAction: tipoAction === FormActions.AGREGAR ? [
    {
      title: "Cancelar",
      buttomProps: {
        type: "buttom",
        onClick: () => setIsVisibleModalDetalle(false),
        color: "secondary"
      }
    },
    {
      title: "Registrar",
      buttomProps: {
        type: "submit",
        // onClick:onSaveDataNewData
      }
    }
  ] : [
    {
      title: "Cancelar",
      buttomProps: {
        type: "buttom",
        color: "secondary",
        onClick: () => setIsVisibleModalDetalle(false)
      }
    },
    {
      title: "Guardar cambios",
      buttomProps: {
        type: "submit",
        //  onClick:onSaveModData
      }
    }

  ],
  imputs: [
    {
      key: "centro_operacion",
      keyValue: "centro_operacion",
      label: "Centro de operacion",
      component: AutoCompleteInputWithLabel,
      inputProps: {
        name: 'centro_operacion',
        fullWidth: true,
        disabled:true,
        isLoading: false,
        onInputChange: onSearchCentroOpModal,
        options: modalFilterOptions.centro_op || [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
    {
      key: "bodega",
      keyValue: "bodega",
      label: "Bodega",
      component: AutoCompleteInputWithLabel,
      inputProps: {
        name: 'bodega',
        fullWidth: true,
        disabled:true,
        isLoading: false,
        onInputChange: onSearchBodegaModal,
        options: modalFilterOptions.bodegas || [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
     {
       key:"detalle",
       keyValue:"detalle",
       label:"Sobrecostos",
       generateDinamyc:true,
       component:InputWithLabel,
       ArrayList:tiposSobreCostos,
       ArrayInputsProps:{
        key:"cod",
        keyValue:"descripcion",
        type:"number"
       }
      
     },
   

  ],
  arrayInputs:[]
};



const onSearchCentroOp = async (value_search, type_enter) => {
 
  if (type_enter && type_enter.length > 3) {
      try {

          const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-centros-operacion-filtros", {
              search_query: type_enter
          });
          console.log({value});
          setCentrosOpOptions(value);
          return value;
      } catch (e) {
          return [];
      }

  }

}

const  setFilterAply = (filtros)=>{
  setFilterSearchPagination(
    {...filterSearchPagination,
    centro_operacion_select:filtros.centro_operacion_select?.value
    }
  )

}

const InputFilters = [
  {
    grid:{
      xs:3,
      md:3,
      sm:3
    },
    InputComponent:AutoCompleteInputWithLabel,
    keyValue:"centro_operacion_select",
    InputComponentProps:{
      label:"centro de operacion",
      fullWidth: true,
      isLoading: false,
      multiple:false,
      size:'small',
  /*     PopperComponent:(props)=><div hidden={!props.open} >
       
         {props.children}
      </div>, */
      onInputChange: onSearchCentroOp,
      options: centrosOpOoptions || [],
      noOptionsText: "Lista vacia",
      getOptionLabel: (option) => option.label,
      isOptionEqualToValue: (option, value) => option.value === value.value,
      filterOptions:(x) => x,
    }
  },
 

  
  ];




return (<>
  {
    isVisibleModalDetalle &&
    <ModalFormGenerador
      isVisible={isVisibleModalDetalle}
      schemaValidator={schema}
      entityValues={productoSeleccionado}
      {
      ...configModal
      }
      onSendForm={onSaveDataForm}
      typeAction={tipoAction}
    />
  }

  <Grid container spacing={2} >
  <Grid item sm={12} xs={12} md={10} >
          <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar bodega por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  centro_operacion_select:null,
             
             
             }
            }
            onApplyFilter={setFilterAply}
          />
        </Grid>
   
    <Grid item sm={12} xs={12} md={12} >

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>

              {
                columnsTable.map(colum => <TableCell key={colum.key} >
                  {<colum.headerRender label={colum.label} />}
                </TableCell>)
              }

            </TableRow>

          </TableHead>
          <TableBody>

            {dataSetProdctos.map(prod =>
              <TableRow key={prod.cod}  >

                {
                  columnsTable.map(Col =>
                    <TableCell key={Col.key + "-" + prod.cod} >
                      {<Col.bodyRender value={prod[Col.keyValue]} />}
                    </TableCell>)
                }

              </TableRow>
            )}

          </TableBody>

        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 40, 60]}
        component="div"
        count={totalRows}
        rowsPerPage={filterSearchPagination.rows_per_page}
        page={filterSearchPagination.page_number}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

    </Grid>
  </Grid>
</>)

}